module.exports = __webpack_public_path__ + "static/media/gift_card.f91e124c.png";